export default __webpack_public_path__ + "static/media/live-feed-exit-page.e5dc2726.svg";